import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'
import {
  funMenu,
  funProjectAuthority
} from "utils/common";

// 用户登录
export function loginByJava(data) {
  return axiosIns({
    url: `/api/pc/employee/login`,
    owner: epmcore,
    method: 'put',
    data: data
  }).then(res => {
    if (res.code === 1000) {
      let menuData = []
      let authority = funMenu(res.data.platformPermissionVOList, "0", menuData)

      res.data.sysPermissionList = authority[0]
      res.data.functionAuthority = authority[1]
      let authorityData = []
      res.data.projectAuthority = null
      console.log('res.data.projectPermissionVOListres.data.projectPermissionVOList:', res.data.projectPermissionVOList)
      if (res.data.projectPermissionVOList)
        res.data.projectAuthority = funProjectAuthority(res.data.projectPermissionVOList, authorityData)
      // res.data.functionAuthority = funFunctionAuthority(res.data.platformPermissionVOList,authorityData)

    }
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 登录前
export function getloginPrepositive(loginbefore) {
  return axiosIns({
    url: `/api/pc/employee/loginPrepositive`,
    owner: epmcore,
    method: 'put',
    data: loginbefore
  })
}


// 获取短信验证码
export function getCaptcha(data) {
  return axiosIns({
    url: `/api/pc/sms/getCaptcha`,
    owner: epmcore,
    method: 'get',
    params: data
  })
}

// 公司注册
export function register(data) {
  return axiosIns({
    url: `/api/pc/company/register`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}

export function getQrCode() {
  return axiosIns({
    url: `/api/pc/wxWork/getLoginQrCode`,
    owner: epmcore,
    method: 'get'
  })
}

export function bindWxWork(data) {
  return axiosIns({
    url: `/api/pc/employee/bindWxWork`,
    owner: epmcore,
    method: 'post',
    data
  })
}

export function verifyIdentifier(data) {
  return axiosIns({
    url: `/api/pc/wxWork/verifyIdentifier`,
    owner: epmcore,
    method: 'post',
    data
  })
}

export function dictGet(params) {
  return axiosIns({
    url: `/api/pc/companyDict/getMap`,
    owner: epmcore,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/login/loginAPI.js